import { gql } from 'apollo-boost';

export const portfolioServices = gql`
  query ($id: ID) {
    allPortfolios(filters: {id: $id}) {
      edges {
        node {
          portfolioId
          name
          services {
            edges {
                node {
                    name
                }
            }
          }
        }
      }
    }
  }
`;
